import { ReviewContractorData } from 'src/lib/fliko/models/estate/contractor.data';
import { EstateData } from 'src/lib/fliko/models/estate/estate.data';
import { ReviewReportData } from 'src/lib/fliko/models/estate/review.data';
import { LocalisedType } from 'src/lib/fliko/models/translation/generic';

export interface CompanyReviewVM {
  id: string;
  estate: EstateData;
  title: string;
  type: LocalisedType | null;
  lastReport: ReviewReportData;
  contractor: ReviewContractorData | null;
  reports: ReviewReportData[];
  status: CompanyReviewStatus;
}

export enum CompanyReviewStatus {
  PLANNED = 'planned',
  UNPLANNED = 'unplanned',
  NO_REPORT = 'reportless',
  DELETED = 'deleted'
}

export interface CompReviewFlags {
  attachments: boolean;
  notes: boolean;
}
